import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type BillingEditionType = 'OmnitrackPlus' | 'Omnitrack' | 'Convbox';
export interface RootState {
  currentWebsite: {
    websiteName: string;
    websiteTitle: string;
    billings: Array<any>;
    shopName: string;
    authInfos: Array<any>;
    billingCode: string;
    billingEdition: BillingEditionType;
    billingVersion: string;
    facebookAuth: boolean;
    billingFeatures: string[];
    company: string;
    contactEmail: string;
    contactName: string;
    platUserId: string;
    shopPlan: string;
    googleAuth: boolean;
    optimizeEvent: string;
    isTrial: boolean;
    eventLevel: Array<string>;
    installTime: number; // 最近一次安装时间
    firstInstallTime: number; // 第一次安装时间
    websitePreferenceInfo: {
      pixel: {
        status?: 'undo' | 'do';
      };
      welcomeStep: Array<{
        completed: boolean;
        modelType: string;
      }>;
    };
    usaId: number;
    currencyCode: string;
    timezoneGmt: string;
    timezone: string;
    timezoneDefault: string;
    timezoneGmtDefault: string;
    virtualSite?: boolean;
  } | null;
  currentWebsiteName: string | null;
  websites: Array<any>;
}

const initialState: RootState = {
  currentWebsite: null,
  currentWebsiteName: null,
  websites: [],
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setWebsite: (state, action: PayloadAction<{ websiteName: string }>) => {
      state.currentWebsiteName = action.payload.websiteName;
    },
    setWebsites: (state, action: PayloadAction<Array<any>>) => {
      state.websites = action.payload;
    },
  },
});

export const appActions = {
  ...appSlice.actions,
};
